module.exports = __webpack_public_path__ + "img/logo.66c04721.png";